var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":_vm.status,"color":"#03543f","is-full-screen":_vm.fullPage}})}
var staticRenderFns = []

export { render, staticRenderFns }